import { useDispatch } from 'react-redux'
import Select from 'react-select/creatable'
import { selectStyles } from 'apps/builder/components/shared'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { BasicMoreSettings } from './BasicMoreSettings'
import UnsecuredAccessToggle from 'apps/builder/components/shared/unsecuredAccessToggle'
import { StandardPdfSettings } from 'apps/builder/components/settings/modal/shared'
import { lib } from '@gocanvas/client'
const { SINGLE_PHOTO_ORIGINAL_TYPE_ID } = lib 

export const PhotoMoreSettings = entry => {
  const { guid, allow_unsecured_access, original_type_id } = entry
  return (
    <>
      <div className="settings--row">
        <ImageSourceDropdown {...entry} />
        <UnsecuredAccessToggle
          guid={guid}
          allow_unsecured_access={allow_unsecured_access}
          mediaType="images"
        />
      </div>
      {original_type_id == SINGLE_PHOTO_ORIGINAL_TYPE_ID && (
        <StandardPdfSettings {...entry} />
      )}
      <BasicMoreSettings
        mobileVisible={false}
        pageBreakAfter={false}
        placeValueIn={false}
        {...entry}
      />
    </>
  )
}

const ImageSourceDropdown = ({ guid, mask }) => {
  const dispatch = useDispatch()
  const isAllowDrawingEnabled = mask === '10'
  const options = [
    {
      value: isAllowDrawingEnabled ? '10' : '00',
      label: 'Camera or Gallery',
    },
    {
      value: isAllowDrawingEnabled ? '11' : '01',
      label: 'Camera Only',
    },
    {
      value: isAllowDrawingEnabled ? '12' : '02',
      label: 'Gallery Only',
    },
  ]

  const imageSourceOptionValue =
    options.find(({ value }) => value == mask) || options[0]

  return (
    <div className="settings--field-type">
      <Select
        styles={selectStyles}
        className="input--placeholder"
        classNamePrefix="react-select"
        value={imageSourceOptionValue}
        options={options}
        onChange={({ value }) => {
          dispatch(
            updateEntry({
              guid,
              mask: value,
            })
          )
        }}
      />
      <label>Image Source</label>
    </div>
  )
}
